import { render, staticRenderFns } from "./AddCanned.vue?vue&type=template&id=2e3fe85c&scoped=true&"
import script from "./AddCanned.vue?vue&type=script&lang=js&"
export * from "./AddCanned.vue?vue&type=script&lang=js&"
import style0 from "./AddCanned.vue?vue&type=style&index=0&id=2e3fe85c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3fe85c",
  null
  
)

export default component.exports